/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { HIGHCHARTS_DEFAULT_OPTIONS } from '../../../Chart.constants';
import { BarChartProps } from '../BarChart.props';

export const getBarChartGeneralOptions = ({
  unit,
  tooltipContent,
  title,
  subtitle,
  showLegend,
}: BarChartProps): Highcharts.Options => {
  const options: Highcharts.Options = { ...HIGHCHARTS_DEFAULT_OPTIONS };

  options.chart = {
    style: {
      fontFamily: 'Open Sans, sans-serif',
    },
    type: 'bar',
  };
  options.tooltip = {
    backgroundColor: '#fff',
    borderColor: 'transparent',
    borderRadius: 8,
    className: 'sds-bar-chart__tooltip',
    shadow: {
      color: 'rgba(0,0,0,0.15)',
      offsetX: 0,
      offsetY: 0,
      opacity: 0.15,
      width: 7,
    },
  };

  options.plotOptions = {
    bar: {
      borderRadius: 0,
      dataLabels: {
        enabled: true,
        format: `{y} ${unit ?? ''}`,
        style: {
          color: '#0774D2',
          fontSize: '16px',
          fontWeight: '700',
        },
      },
    },
  };
  options.responsive = {
    rules: [
      {
        chartOptions: {
          xAxis: {
            labels: {
              enabled: false,
            },
            // workaround - as of highcharts v11 testing is bugged in that particular manner: https://github.com/highcharts/highcharts/issues/19077#issuecomment-1748854197
            width: 400,
          },
        },
        condition: {
          maxWidth: 521,
        },
      },
    ],
  };

  if (showLegend) {
    options.legend = {
      enabled: showLegend,
    };
  }

  if (title) {
    options.title = {
      align: 'left',
      style: {
        color: '#3D3D3D',
        fontFamily: 'Open Sans, sans-serif',
        fontSize: '16px',
        fontWeight: '700',
      },
      text: title,
    };
  }

  if (subtitle) {
    options.subtitle = {
      align: 'left',
      style: {
        color: '#707070',
        fontFamily: 'Open Sans, sans-serif',
        fontSize: '14px',
        fontWeight: '400',
      },
      text: subtitle,
      useHTML: true,
    };
  }
  if (tooltipContent) {
    options.tooltip = {
      ...options.tooltip,
      formatter: function formatter(): string {
        return tooltipContent(this);
      },
      useHTML: true,
    };
  }

  return options;
};
